module.exports = __webpack_public_path__ + "static/media/PG.9057fd58.svg";


//////////////////
// WEBPACK FOOTER
// ./src/svgs/flags/PG.svg
// module id = 338
// module chunks = 0